import $ from 'jquery';
import { request, validatePhone, notificationInline } from './utility';

$('input[name="receivethegoods"]').on('change', function (e) {
  var value = e.target.value;
  $('.receivethegoods').hide();
  $('#receivethegoods-' + value).show();
});

$("input[name='isXuatHoaDon']").on('change', function (e) {
  $('#box-vat').slideToggle().toggleClass('opened');
  var isVisible = $('#box-vat').is('.opened');
  if (!isVisible) {
    $('input[name="txtCongty"]').val('');
    $('input[name="txtDiaChiCongTy"]').val('');
    $('input[name="txtMaSoThue"]').val('');
  }
});

// START Cấu hình bộ lọc ---------------------------------
var keyNgonNgu = $('#filter_ngonngu').val();
var idTinhThanh = $('#filter_tinhthanh_value').val();
var idQuanHuyen = $('#filter_quanhuyen_value').val();
var idPhuongXa = $('#filter_phuongxa_value').val();
showQuanHuyen(idTinhThanh, idQuanHuyen);
showPhuongXa(idQuanHuyen, idPhuongXa);
$('#filter_tinhthanh').on('change', function (e) {
  var value = e.target.value;
  showQuanHuyen(value);
  showPhuongXa(0, 0);
});
$('#filter_quanhuyen').on('change', function (e) {
  var value = e.target.value;
  showPhuongXa(value);
});

function showQuanHuyen(idTinhThanh, idQuanHuyen) {
  $('#show-quan-huyen select').remove();
  const data = {
    id: idTinhThanh,
    langCode: keyNgonNgu,
  };
  $.when(request('GET', APP_URL + '/api/divisions/districts', data)).done(
    function (resposive) {
      const res = JSON.parse(resposive);
      var selectClone = $('#select-clone select#filter_quanhuyen').clone(true);
      selectClone.attr('name', 'filter_quanhuyen');
      selectClone.attr('id', 'filter_quanhuyen');
      if (res && res?.data && res?.data?.length != 0) {
        res?.data.map(function (elm) {
          var optionClone = $(
            '#select-clone select#filter_quanhuyen option',
          ).clone(true);
          if (idQuanHuyen == elm.id) {
            optionClone.attr('selected', 'selected');
          }

          optionClone.attr('value', elm.id);
          optionClone.html(elm.name);
          selectClone.append(optionClone);
        });
      }
      $('#show-quan-huyen').append(selectClone);
    },
  );
}

function showPhuongXa(idQuanHuyen, idPhuongXa) {
  $('#show-phuong-xa select').remove();
  var data = {
    id: idQuanHuyen,
    langCode: keyNgonNgu,
  };
  $.when(request('GET', APP_URL + '/api/divisions/wards', data)).done(
    function (resposive) {
      const res = JSON.parse(resposive);
      var selectClone = $('#select-clone select#filter_phuongxa').clone(true);
      selectClone.attr('name', 'filter_phuongxa');
      selectClone.attr('id', 'filter_phuongxa');
      if (res && res?.data && res?.data?.length != 0) {
        res?.data.map(function (elm) {
          var optionClone = $(
            '#select-clone select#filter_phuongxa option',
          ).clone(true);
          if (idPhuongXa == elm.id) {
            optionClone.attr('selected', 'selected');
          }
          optionClone.attr('value', elm.id);
          optionClone.html(elm.name);
          selectClone.append(optionClone);
        });
      }
      $('#show-phuong-xa').append(selectClone);
    },
  );
}
// END

// START Get dữ liệu, kiểm tra và tạo đơn hàng
function removedError() {
  $('input').removeClass('error');
  $('textarea').removeClass('error');
  $('select').removeClass('error');
}

function resetFormValue() {
  $('input[type="text"]').val('');
  $('textarea').val('');
}

function checkFormDonViHanhChinh(data) {
  var isCheck = true;
  data.map(function (item) {
    switch (true) {
      case item.name === 'filter_tinhthanh' && (!item.value || item.value == 0):
        $('select[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'filter_quanhuyen' && (!item.value || item.value == 0):
        $('select[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'filter_phuongxa' && (!item.value || item.value == 0):
        $('select[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'txtAddress' && !item.value:
        $('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      default:
        break;
    }
  });
  return isCheck;
}

function checkFormThongTinXuatHoaDon(data) {
  var isCheck = true;
  data.map(function (item) {
    switch (true) {
      case item.name === 'txtCongty' && !item.value:
        $('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'txtDiaChiCongTy' && !item.value:
        $('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'txtMaSoThue' && !item.value:
        $('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      default:
        break;
    }
  });
  return isCheck;
}

function checkValidate(data) {
  removedError();
  var isCheck = true;
  data.map(function (item) {
    switch (true) {
      case item.name === 'sex' && !item.value:
        $('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'txtName' && !item.value:
        $('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'txtPhone' && !validatePhone(item.value):
        $('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'receivethegoods' &&
        item.value == 1 &&
        !checkFormDonViHanhChinh(data):
        isCheck = false;
        break;
      case item.name === 'isXuatHoaDon' &&
        item.value == '1' &&
        !checkFormThongTinXuatHoaDon(data):
        isCheck = false;
        break;
      default:
        break;
    }
  });
  return isCheck;
}

function callApiSaveData(data) {
  const button = document.getElementById('payment_order');
  button.disabled = true;
  $.when(
    request('POST', APP_URL + '/api/cart/payment-orders', data, data[0].value),
  ).done(function (resposive) {
    const res = JSON.parse(resposive);
    if (res && res.data) {
      button.disabled = false;
      resetFormValue();
      $('#totalAmount').html(0);
      return (window.location.href = res.data);
    }

    $('#totalAmount').html(0);
    return location.reload();
  });
}

$('#payment_order').on('click', function (e) {
  e.preventDefault();
  var data = $('form[name="formShoppingCart"]').serializeArray();
  var isCheck = checkValidate(data);
  if (!isCheck) {
    return;
  }

  callApiSaveData(data);
});
// END

// START pay order
$('.payordertype').on('change', function (e) {
  const value = e.target.value;
  $('#showpayordertype').show();
  $('#showpayordertype li').css('display', 'none');
  $('#showpayordertype li#' + value).css('display', 'block');
});
$('#paySubmit').on('click', function (e) {
  e.preventDefault();
  $('button[name="paySubmit"]').attr('disabled', true);
  const data = $('form[name="payOrderForm"]').serializeArray();
  $.when(
    request('POST', APP_URL + '/api/cart/form-of-Payment', data, data[0].value),
  ).done(function (resposive) {
    const res = JSON.parse(resposive);
    if (res && res.data) {
      $('.pay-order-type').hide();
      $('.pay-order-footer').hide();
      $('.title-pay-box-cart').html('HÌNH THỨC THANH TOÁN');
      $('#js-title-pay').html('Đặt hàng thành công');
      $('.shownotification').show();
      notificationInline('SUCCESS', 'Mua hàng thành công!', 'shownotification');
    }

    $('button[name="paySubmit"]').attr('disabled', false);
  });
});
// END pay order
